class OpenMinicart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.handle.bind(this));
  }

  handle() {
    document.body.classList.add("minicart-opening");
  }
}

customElements.define("open-minicart", OpenMinicart);

class CloseMinicart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.handle.bind(this));
  }

  handle() {
    document.body.classList.remove("minicart-opening");
  }
}

customElements.define("close-minicart", CloseMinicart);

class Minicart extends HTMLElement {
  constructor() {
    super();
  }

  renderCart(submitButton, checkOpenCart) {
    fetch("/cart?view=mini-cart&timestamp=" + Date.now(), {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        document.querySelector("mini-cart").innerHTML = html;

        let itemCount = parseInt(document.querySelector("mini-cart .js-mini-cart-count").getAttribute("data-count"), 10);
        document.querySelectorAll(".js-header-cart-count").forEach((el) => {
          el.innerHTML = itemCount;
          if (itemCount > 0) {
            el.parentNode.classList.remove("hidden");
          } else {
            el.parentNode.classList.add("hidden");
          }
        });

        if (submitButton) {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
        }

        if (checkOpenCart) {
          setTimeout(function () {
            document.body.classList.add("minicart-opening");
          }, 500);
        }

        if (localStorage.getItem("shippingRates") != null && localStorage.getItem("shippingRates") != "") {
          if (document.querySelectorAll("shipping-rates").length > 0) {
            document.body.classList.add("cart-loading");
            
            let shippingCode = localStorage.getItem("shippingRates");
            const shippingRates = document.querySelector("shipping-rates");
            shippingRates.querySelector('input[name="postcode"]').value = shippingCode;
            shippingRates.showShipping();
            shippingRates.retrieveShipping(shippingCode);
          } else {
            if (document.body.classList.contains("cart-loading")) {
              document.body.classList.remove("cart-loading");
            }
          }
        } else {
          if (document.body.classList.contains("cart-loading")) {
            document.body.classList.remove("cart-loading");
          }
        }
      });
    });
  }

  updateQty(line, quantity) {
    const formData = {
      line: line,
      quantity: quantity,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        this.renderCart();
      })
      .catch((error) => {
        console.log(error);
        alert(window.cartStrings.error);
      });
  }
}

customElements.define("mini-cart", Minicart);

class MinicartQty extends HTMLElement {
  constructor() {
    super();

    // this.input = this.querySelector('input');
    // this.input.addEventListener('keydown', this.onInputValidate.bind(this));

    // this.querySelectorAll('button').forEach(
    //   (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    // );

    this.select = this.querySelector("select");
    if (!this.select) return;

    this.select.addEventListener("change", this.onSelectChange.bind(this));
  }

  onInputValidate(evt) {
    if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
      evt.preventDefault();
    }
  }

  onButtonClick(evt) {
    this.button = evt.target;
    this.type = this.button.getAttribute("data-type");
    this.currentValue = parseInt(this.input.value);

    if (this.type == "decrease") {
      this.input.value = this.currentValue - 1;
    } else {
      this.input.value = this.currentValue + 1;
    }

    this.onUpdateQty(this.input);
  }

  onSelectChange() {
    if (localStorage.getItem("shippingRates") != null) {
      localStorage.removeItem("shippingRates");
    }
    
    document.body.classList.add("cart-loading");
    this.onUpdateQty(this.select);
  }

  onUpdateQty(target) {
    this.line = target.getAttribute("data-line");

    const minicart = document.querySelector("mini-cart");
    minicart.updateQty(this.line, target.value);
  }
}

customElements.define("minicart-qty", MinicartQty);

class MinicartRemove extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onUpdateQty.bind(this));
  }

  onUpdateQty() {
    document.body.classList.add("cart-loading");
    
    this.variantId = this.getAttribute("data-variant");
    if (document.querySelectorAll('.js-update-cart[data-variant="' + this.variantId + '"]').length) {
      document.querySelectorAll('.js-update-cart[data-variant="' + this.variantId + '"]').forEach((btn) => {
        btn.classList.remove("js-update-cart");
      });
    }

    this.line = this.getAttribute("data-line");

    const minicart = document.querySelector("mini-cart");
    minicart.updateQty(this.line, 0);
  }
}

customElements.define("minicart-remove", MinicartRemove);

class MinicartBundleRemove extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.removeBundle.bind(this));
  }

  removeBundle() {
    document.body.classList.add("cart-loading");

    this.wrap = this.parentNode.querySelector(".bundle-info");
    this.bundleProducts = this.wrap.querySelectorAll(".main-cart-sticky__item");
    this.formData = {
      updates: {},
    };
    for (let i = 0; i < this.bundleProducts.length; i++) {
      const currentId = this.bundleProducts[i].getAttribute("data-key");
      this.formData["updates"][currentId] = 0;
    }

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.formData),
    })
      .then((response) => {
        const minicart = document.querySelector("mini-cart");
        minicart.renderCart();
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

customElements.define("minicart-bundle-remove", MinicartBundleRemove);

class ShippingRates extends HTMLElement {
  constructor() {
    super();

    this.showInput = this.querySelector('.js-open-shipping-rates');
    if (this.showInput) {
      this.showInput.addEventListener("click", this.showShipping.bind(this));
    }

    this.input = this.querySelector('input[name="postcode"]');
    if (this.input) {
      this.input.addEventListener("keydown", this.preventSubmit.bind(this));
    }

    this.submitButton = this.querySelector('.js-calculator-shipping');
    if (this.submitButton) {
      this.submitButton.addEventListener("click", this.getInputValue.bind(this));
    }
  }

  showShipping() {
    if (this.querySelectorAll('.shipping-rates-wrap').length > 0) {
      this.querySelector('.shipping-rates-wrap').classList.remove('hidden');
      this.classList.add('opening');
    }
  }

  preventSubmit(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();

      this.getInputValue();
    }
  }

  getInputValue() {
    this.inputValue = this.input.value;
    this.retrieveShipping(this.inputValue);
  }

  async retrieveShipping(inputValue) {
    this.inputValue = inputValue;
    if (this.inputValue != '') {
      localStorage.setItem("shippingRates", this.inputValue);
      document.body.classList.add("cart-loading");

      this.cartItems = await fetch("/cart.js");
      this.cartItems = await this.cartItems.json();

      const itemSource = this.cartItems.items;
      const items = itemSource.map(item => {
        return {
          sku: item.sku,
          quantity: item.quantity,
          grams: item.grams,
          requires_shipping: item.requires_shipping,
          taxable: item.taxable,
          product_id: item.product_id,
          variant_id: item.variant_id,
          key: item.key
        }
      });

      let addressData = {
        destination: {
          // country: 'AU',
          postal_code: this.inputValue,
        },
        items: items,
        currency: "AUD",
      };
      let response = await fetch("https://parcel-intelligence.com/cs/api_ex.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "HTTP_X_STORE_NAME": "petzyo.myshopify.com",
          "HTTP_X_STORE_TOKEN": "5055e068263e8752d26a456bc4b4727cc57eb37d",
          "HTTP_X_SHOW_DEBUG": false
        },
        body: JSON.stringify(addressData),
      });
      if (window.shopUrl.includes("dev")) {
        response = await fetch("https://parcel-intelligence.com/cs/api_ex.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "HTTP_X_STORE_NAME": "petzyo-dev.myshopify.com",
            "HTTP_X_STORE_TOKEN": "d526a9d1f7a0216c9edd5657afd3abab579f8d46",
            "HTTP_X_SHOW_DEBUG": false
          },
          body: JSON.stringify(addressData),
        });
      }

      this.data = await response.json();

      if (this.data.rates[0].service_code == "ERROR") {
        let itemText = "item";
        let numberOfError = this.data.rates[0].errors.length;
        if (numberOfError > 1) {
          itemText = "items";
        }
        this.querySelector('.shipping-rates-result-fail').innerHTML = numberOfError + " " + itemText + " can’t be shipped to your postcode";

        this.querySelector('.shipping-rates-result').classList.add('hidden');
        this.querySelector('.shipping-rates-result-fail').classList.remove('hidden');

        document.querySelector('.mini-cart__checkout').classList.add('hidden');
        document.querySelector('shipping-remove').classList.remove('hidden');

        if (document.querySelectorAll('.shipping-error').length > 0) {
          document.querySelectorAll('.shipping-error').forEach((item) => {
            item.classList.remove('shipping-error');
          });
        }

        if (numberOfError > 0) {
          this.data.rates[0].errors.forEach((item) => {
            if (item.clientKey) {
              if (document.querySelectorAll('.mini-cart__item[data-key="' + item.clientKey + '"]').length > 0) {
                document.querySelector('.mini-cart__item[data-key="' + item.clientKey + '"]').classList.add('shipping-error');
              }

              if (document.querySelectorAll('.mini-cart__item-bundle[data-key="' + item.clientKey + '"]').length > 0) {
                document.querySelector('.mini-cart__item-bundle[data-key="' + item.clientKey + '"]').closest('.bundle-wrap').classList.add('shipping-error');
              }
            }
          });
        }
      } else {
        if (this.data.rates[0].service_name && this.querySelectorAll('.js-shipping-address').length > 0) {
          this.querySelector('.js-shipping-address').innerHTML = this.inputValue + ', ' + this.data.rates[0].service_name;
        }

        if (this.data.rates[0].total_price >= 0 && this.querySelectorAll('.js-shipping-price').length > 0) {
          if (this.data.rates[0].total_price == 0) {
            this.querySelector('.js-shipping-price').innerHTML = 'Free';
          } else {
            this.querySelector('.js-shipping-price').innerHTML = Shopify.formatMoney(this.data.rates[0].total_price);
          }
        }

        this.querySelector('.shipping-rates-result').classList.remove('hidden');
        this.querySelector('.shipping-rates-result-fail').classList.add('hidden');

        document.querySelector('.mini-cart__checkout').classList.remove('hidden');
        document.querySelector('shipping-remove').classList.add('hidden');
      }

      document.body.classList.remove("cart-loading");
    }
  }
}

customElements.define("shipping-rates", ShippingRates);

class ShippingRemove extends HTMLElement {
  constructor() {
    super();

    this.shippingRemove = this;
    if (this.shippingRemove) {
      this.shippingRemove.addEventListener("click", this.removeProduct.bind(this));
    }
  }

  async removeProduct() {
    if (document.querySelectorAll('.mini-cart__item.shipping-error').length > 0 || document.querySelectorAll('.bundle-wrap.shipping-error').length > 0) {
      document.body.classList.add("cart-loading");
      
      let formData = {
        updates: {},
      };

      if (document.querySelectorAll('.mini-cart__item.shipping-error').length > 0) {
        document.querySelectorAll('.mini-cart__item.shipping-error').forEach((item) => {
          let itemKey = item.getAttribute('data-key');
          formData["updates"][itemKey] = 0;
        });
      }

      if (document.querySelectorAll('.bundle-wrap.shipping-error').length > 0) {
        document.querySelectorAll('.bundle-wrap.shipping-error').forEach((bundle) => {
          let bundleProducts = bundle.querySelectorAll(".main-cart-sticky__item");
          for (let i = 0; i < bundleProducts.length; i++) {
            let itemKey = bundleProducts[i].getAttribute("data-key");
            formData["updates"][itemKey] = 0;
          }
        });
      }

      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          const minicart = document.querySelector("mini-cart");
          minicart.renderCart();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
}

customElements.define("shipping-remove", ShippingRemove);

document.addEventListener('DOMContentLoaded', function () {
  if (localStorage.getItem("shippingRates") != null) {
    localStorage.removeItem("shippingRates");
  }
});